export const fileKindMap = {
  checks: 'checks',
};
